module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-create text-dark"
  }, [_c('DModal', {
    attrs: {
      "show-close": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "task-create__modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "task-create__header",
    class: {
      'task-create__header--create-subject': _vm.canSchedule
    },
    style: ({
      'backgroundColor': _vm.color
    })
  }, [_c('div', {
    staticClass: "task-create__header-main"
  }, [_c('h3', [(_vm.name.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_task']))]) : _c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), (_vm.canCopyToSharedCalendar) ? _c('DDropdown', {
    staticClass: "task-create__header-menu",
    attrs: {
      "isBottomStart": false,
      "propOffset": [0, 8]
    }
  }, [_c('ul', {
    staticClass: "task-create__copy-calendar-list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    staticClass: "task-create__menu-heading"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_to_shared_calendar']))]), _vm._v(" "), _vm._l((_vm.copyCalendarOptions), function(calendar) {
    return _c('li', {
      key: calendar.id,
      on: {
        "click": function($event) {
          return _vm.copyTaskToSharedCalendar(calendar.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon-clipboard2"
    }), _vm._v(" " + _vm._s(calendar.name) + "\n              ")])
  })], 2)]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowSamletTid) ? _c('div', {
    staticClass: "task-create__total-time"
  }, [_c('span', {
    staticClass: "task-create__total-time-value"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['total_time']) + ": " + _vm._s(_vm.samletTid.total) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_unit']))]), _vm._v(" "), _c('span', {
    staticClass: "task-create__total-time-breakdown"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['teaching']) + " " + _vm._s(_vm.samletTid.teaching) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_unit']) + " · " + _vm._s(_vm.i18n[_vm.locale]['preparation']) + " " + _vm._s(_vm.samletTid.prep) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_unit']))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-create__close icon__bg-circle",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('form', {
    staticClass: "task-create__body",
    attrs: {
      "id": "task-create"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.isLoadingFreshData) ? _c('div', {
    staticClass: "task-create__loading-overlay"
  }, [_c('div', {
    staticClass: "do-spinner"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-create__form"
  }, [(!_vm.quickCreate) ? [_c('div', {
    staticClass: "input-group__flex input-group__flex--top-row"
  }, [_c('div', {
    staticClass: "input-group input-group__title input-flex-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['task_title']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "name",
    staticClass: "d-input",
    class: {
      'input--error': _vm.formErrors['name']
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.i18n[_vm.locale]['ex_task']
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        return _vm.removeErrors('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__hours-top"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours']) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hours),
      expression: "hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "d-input",
    class: {
      'input--error': _vm.formErrors['hours']
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "blur": [function($event) {
        return _vm.removeErrors('hours')
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isShowNorwegianPreparationDropdown) ? _c('div', {
    staticClass: "input-group input-group__preparation"
  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preparation),
      expression: "preparation"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.preparation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preparation = $event.target.value
      }
    }
  })]) : (_vm.isShowDanishPreparationFactorField && !_vm.isDanishPrepBinaryOnOwnRow) ? _c('DkPreparationFactorControl', {
    attrs: {
      "subject-type": _vm.subjectType,
      "school-prep-factor": _vm.schoolSettings.prepFactor,
      "labels": _vm.danishPreparationControlLabels,
      "input-class": "d-input",
      "wrap-class": "input-group input-group__preparation"
    },
    model: {
      value: (_vm.preparation),
      callback: function($$v) {
        _vm.preparation = $$v
      },
      expression: "preparation"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
    staticClass: "input-group"
  }, [_c('DkPreparationFactorControl', {
    attrs: {
      "subject-type": _vm.subjectType,
      "school-prep-factor": _vm.schoolSettings.prepFactor,
      "labels": _vm.danishPreparationControlLabels,
      "input-class": "d-input",
      "wrap-class": "input-group input-group__preparation dk-prep-factor-full-width"
    },
    model: {
      value: (_vm.preparation),
      callback: function($$v) {
        _vm.preparation = $$v
      },
      expression: "preparation"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_user']))]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "USER",
      "preSelectedItems": _vm.calendars,
      "showTags": true,
      "itemsThatCantBeDeleted": _vm.usersWithEvents
    },
    on: {
      "update": _vm.setSelectedUsers
    }
  })], 1), _vm._v(" "), (!_vm.quickCreate) ? [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "create-as-subject"
  }, [_c('div', {
    staticClass: "create-as-subject__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDateFields.apply(null, arguments)
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "propOn": _vm.isShowDateFields,
      "allowChanges": false
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_dates_on_overview']))])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.isShowDateFields) ? _c('div', {
    staticClass: "input-group__flex"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['from_date']))]), _vm._v(" "), _c('div', {
    staticClass: "date-field"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.fromDate || _vm.today,
      "width100": true
    },
    on: {
      "changed": _vm.setFromDate
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['to_date']))]), _vm._v(" "), _c('div', {
    staticClass: "date-field"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.toDate || _vm.today,
      "width100": true
    },
    on: {
      "changed": _vm.setToDate
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_type']))]), _vm._v(" "), _c('SubjectFormSubjectType', {
    attrs: {
      "calendar-type": "user",
      "subject-type": _vm.subjectType,
      "isInTasks": true
    },
    on: {
      "change": _vm.setSubjectType
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.quickCreate) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_as']) + " "), _c('span', {
    staticClass: "pill pill--grey hint--top-right",
    attrs: {
      "aria-label": "Vælg briktype for at ændre"
    }
  }, [_vm._v(_vm._s(_vm.hoursType))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group__flex"
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hours),
      expression: "hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "d-input",
    class: {
      'input--error': _vm.formErrors['hours']
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "blur": [function($event) {
        return _vm.removeErrors('hours')
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.quickCreate) ? [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "create-as-subject",
    class: {
      'create-as-subject--disabled': _vm.cannotChangeCanSchedule
    }
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.cannotChangeCanSchedule ? {
        arrow: true,
        placement: 'top'
      } : {
        trigger: 'manual'
      }),
      expression: "cannotChangeCanSchedule ? { arrow: true, placement: 'top' } : { trigger: 'manual' }"
    }],
    staticClass: "create-as-subject__inner",
    class: {
      'create-as-subject__inner--disabled': _vm.cannotChangeCanSchedule
    },
    attrs: {
      "content": _vm.cannotChangeCanScheduleTooltip
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleCanSchedule.apply(null, arguments)
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "propOn": _vm.canSchedule,
      "allowChanges": false
    },
    on: {
      "changed": _vm.setIsCreateAsSubject
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['can_be_scheduled']))])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.canSchedule) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['duration']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.duration),
      expression: "duration",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "d-input",
    class: {
      'input--error': _vm.formErrors['duration']
    },
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.duration)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "blur": [function($event) {
        return _vm.removeErrors('duration')
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duration = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formErrors['duration']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['duration'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.isCreateInOtherCalendarAnOption && !_vm.editTask) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_in_calendar']))]), _vm._v(" "), _c('SelectOtherCal', {
    attrs: {
      "selectedCalendarId": _vm.selectedOtherCalendarId,
      "calendarType": _vm.taskCalendarType
    },
    on: {
      "changed": _vm.setSelectedOtherCalendarId
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.editTask && _vm.getOtherCalendarName(_vm.selectedOtherCalendarId)) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['created_in_calendar']))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.getOtherCalendarName(_vm.selectedOtherCalendarId)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "initialColor": _vm.color
    },
    on: {
      "changedColor": _vm.setColor
    }
  })], 1)], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__submit task-create__footer"
  }, [_c('div', {
    staticClass: "input-group__submit__left"
  }, [(_vm.editTask) ? [(_vm.usersWithEvents.length < 1) ? _c('button', {
    staticClass: "hint--right bttn--warning",
    attrs: {
      "aria-label": "Slet opgaven"
    },
    on: {
      "click": _vm.deleteTask
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _c('div', {
    staticClass: "hint--right",
    attrs: {
      "aria-label": _vm.i18n[_vm.locale]['cannot_be_deleted']
    }
  }, [_c('button', {
    staticClass: "bttn bttn--disabled"
  }, [_c('span', {
    staticClass: "icon-bin"
  })])])] : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))])], 2), _vm._v(" "), _c('div', {
    staticClass: "input-group__submit__right"
  }, [(!_vm.editTask) ? [_c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isSubmittingTask
    },
    on: {
      "click": function($event) {
        return _vm.createTask(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['save_and_new']) + "\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'top',
        zIndex: 12312312312312
      }),
      expression: "{\n                          placement: 'top',\n                          zIndex: 12312312312312\n                        }"
    }],
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmittingTask
    },
    attrs: {
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": function($event) {
        return _vm.createTask(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['save_and_close']) + "\n                ")])] : _vm._e(), _vm._v(" "), (_vm.editTask) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'top',
        zIndex: 12312312312312
      }),
      expression: "{\n                        placement: 'top',\n                        zIndex: 12312312312312\n                      }"
    }],
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmittingTask
    },
    attrs: {
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": _vm.updateTask
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_task']) + "\n              ")]) : _vm._e()], 2)])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-overlay animatedFast fadeIn"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-052ac37a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionTasksFromSubjectsCreate.vue
// module id = 1738
// module chunks = 1